// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useMemo } from 'react';
import { useParties } from '../../../../contexts/PartiesContext';
import { useParticipantServices } from '../onboarding/useParticipantServices';
import useRegistrarService from '../onboarding/useRegistrarService';

export type AllowListViewMode = 'registrar' | 'participant';

export const useAllowListRole = () => {
  const registrarService = useRegistrarService();
  const participantServices = useParticipantServices();
  const { party } = useParties();

  const isRegistrar = !!registrarService.data;
  const isParticipant =
    participantServices.data?.some((service) => service.payload.participant === party) ?? false;

  const mode = useMemo<AllowListViewMode | null>(() => {
    if (isRegistrar) {
      return 'registrar';
    }

    if (isParticipant) {
      return 'participant';
    }

    return null;
  }, [isParticipant, isRegistrar]);

  return {
    isLoading: registrarService.isLoading || participantServices.isLoading,
    isParticipant,
    isRegistrar,
    mode,
  };
};

export default useAllowListRole;
